const actions = {
    SET_LOADING_STATUS      : 'SET_LOADING_STATUS',
    SET_VENUE               : 'SET_VENUE',
    SET_ORDINALS            : 'SET_ORDINALS',
    SET_STRUCTURES          : 'SET_STRUCTURES',
    SET_LEVELS              : 'SET_LEVELS',
    SET_THEME               : 'SET_THEME',
    SET_MAP_STYLE           : 'SET_MAP_STYLE',
    SET_SPRITES             : 'SET_SPRITES',
    SET_VENUE_DROPDOWNS     : 'SET_VENUE_DROPDOWNS',
    SET_BASEMAP_BOUNDING_BOX: 'SET_BASEMAP_BOUNDING_BOX',
    SET_IS_MIGRATED         : 'SET_IS_MIGRATED',

    ADD_FEATURES       : 'ADD_FEATURES',
    UPSERT_ENTITIES    : 'UPSERT_ENTITIES',
    SET_VENUE_SUMMARIES: 'SET_VENUE_SUMMARIES',

    VENUE_LOADING_STARTED : 'VENUE_LOADING_STARTED',
    VENUE_LOADING_FINISHED: 'VENUE_LOADING_FINISHED',
    VENUE_LOADING_FAILED  : 'VENUE_LOADING_FAILED',
    MAP_LOADING_STARTED   : 'MAP_LOADING_STARTED',
    MAP_LOADING_FINISHED  : 'MAP_LOADING_FINISHED',
    MAP_LOADING_FAILED    : 'MAP_LOADING_FAILED',

    REMOVE_FEATURE        : 'REMOVE_FEATURE',
    RESET                 : 'RESET',

    PERFORM_VALIDATION    : 'PERFORM_VALIDATION',
}

const LOADING_STATUS_LOADING = 'LOADING'
const LOADING_STATUS_LOADED  = 'LOADED'
const LOADING_STATUS_FAILED  = 'FAILED'

export {
    actions,
    LOADING_STATUS_LOADING,
    LOADING_STATUS_LOADED,
    LOADING_STATUS_FAILED,
}

